import { ApiResponse, UploadResult } from '@packages/global';
import { httpClient } from '../httpClient';

export const imageUploadApi = {
  async uploadImage(file: File): Promise<UploadResult> {
    const formData = new FormData();
    formData.append('image', file);

    const response = await httpClient.instance.post<ApiResponse<UploadResult>>('/user/upload/image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.message || '图片上传失败');
    }

    return response.data.data;
  }
};